export default "__VITE_ASSET__cfa081d1__"